import { render, staticRenderFns } from "./Breakpoint.vue?vue&type=template&id=c5580980&scoped=true"
import script from "./Breakpoint.vue?vue&type=script&lang=js"
export * from "./Breakpoint.vue?vue&type=script&lang=js"
import style0 from "./Breakpoint.vue?vue&type=style&index=0&id=c5580980&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5580980",
  null
  
)

export default component.exports